



























import { Component, Vue, Prop } from "vue-property-decorator";
import Rules, { ValidationFunctionType } from "../code/ValidationRules";

@Component
export default class TextFieldWithMask extends Vue {
  @Prop([String, Number])
  value!: string | number;

  @Prop(String)
  label!: string;

  @Prop(String)
  mask!: string;

  @Prop(String)
  placeholder: string | undefined;

  @Prop(String)
  help: string | undefined;

  @Prop(String)
  type: string | undefined;

  @Prop(String)
  suffix: string | undefined;

  @Prop()
  rules: ValidationFunctionType[] | undefined;

  @Prop(String)
  errorMessage: string | undefined;

  @Prop(Boolean)
  isNumber: boolean | undefined;

  validationRules = Rules;

  updateValue(value: string): void {
    if (this.isNumber) {
      const intValue = parseInt(value, 10);
      this.$emit("input", intValue);
    } else {
      this.$emit("input", value);
    }
  }
}
